import {forwardRef, useEffect, useRef, useState} from "react";
import {mobileImage} from "../mobileAssets";

const FeatureScreen = forwardRef(function FeatureScreen({features, activeFeature, onChangeFeature}, ref) {
    const pointerRef = useRef(null);
    const animationTimerRef = useRef(null);
    const [displayedFeature, setDisplayedFeature] = useState(activeFeature);
    const [transition, setTransition] = useState(null);

    useEffect(() => {
        if (!transition) setDisplayedFeature(activeFeature);
    }, [activeFeature, transition]);

    useEffect(() => () => {
        if (animationTimerRef.current) window.clearTimeout(animationTimerRef.current);
    }, []);

    const requestFeatureChange = function (offset) {
        if (!features.length || transition) return;
        const nextFeature = (activeFeature + offset + features.length) % features.length;
        if (nextFeature === activeFeature) return;
        setTransition({from: activeFeature, to: nextFeature, direction: offset > 0 ? "next" : "prev"});
        onChangeFeature(offset);
        animationTimerRef.current = window.setTimeout(function () {
            setDisplayedFeature(nextFeature);
            setTransition(null);
            animationTimerRef.current = null;
        }, 520);
    };

    const handlePointerDown = function (event) {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        if (event.target.closest && event.target.closest("button")) return;
        pointerRef.current = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY
        };
        event.currentTarget.setPointerCapture?.(event.pointerId);
    };

    const handlePointerUp = function (event) {
        const pointer = pointerRef.current;
        if (!pointer || pointer.id !== event.pointerId) return;
        pointerRef.current = null;
        event.currentTarget.releasePointerCapture?.(event.pointerId);

        const deltaX = event.clientX - pointer.x;
        const deltaY = event.clientY - pointer.y;
        const isHorizontalSwipe = Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
        if (!isHorizontalSwipe) return;
        requestFeatureChange(deltaX < 0 ? 1 : -1);
    };

    const handlePointerCancel = function () {
        pointerRef.current = null;
    };

    return (
        <div
            ref={ref}
            className="page_f mobile-section-page"
            onPointerDown={handlePointerDown}
            onPointerUp={handlePointerUp}
            onPointerCancel={handlePointerCancel}
        >
            <p className="mobile-quality-note">*游戏研发中，非最终品质。</p>
            <div className={`slide${transition ? ` is-transitioning ${transition.direction}` : ""}`}>
                <img src={mobileImage(features[displayedFeature])} className="picture slide-current" alt={`游戏特色 ${displayedFeature + 1}`}/>
                {transition ? <img src={mobileImage(features[transition.to])} className="picture slide-incoming" alt={`游戏特色 ${transition.to + 1}`}/> : null}
            </div>
            <button className="btn prev" type="button" onClick={() => requestFeatureChange(-1)} aria-label="上一个特色"><img src={mobileImage("three_05.png")} alt=""/></button>
            <button className="btn next" type="button" onClick={() => requestFeatureChange(1)} aria-label="下一个特色"><img src={mobileImage("three_08.png")} alt=""/></button>
            <img src={mobileImage("three_13.png")} className="down" alt="向下浏览"/>
        </div>
    );
});

export default FeatureScreen;
